import { createFileRoute } from '@tanstack/react-router';
import { lerBuscaOrcamento, OrcamentoPage } from '@/components/orcamento';

export const Route = createFileRoute('/_app/vender/orcamentos/$id')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaOrcamento(bruto),
  component: OrcamentoRota,
});

function OrcamentoRota() {
  const { id } = Route.useParams();
  const { versao, guia } = Route.useSearch();
  return <OrcamentoPage key={id} id={id} versao={versao} guia={guia} />;
}
